<template>
  <a-modal
    v-if="showSelectedDialog"
    :title="title"
    :width="width"
    :footer="null"
    v-model="showSelectedDialog"
    @cancel="onCloseEvent"
  >
    <slot name="tips"></slot>
    <search-page-view
      ref="pageList"
      :before-search="beforeSearch"
      :columns="columns"
      :col="col"
      :button-col="buttonCol"
      :query-params="queryParams"
      :query-path="queryPath"
      :params-path="paramsPath"
      :base-key="baseKey"
      :left-space="leftSpace"
      :custom-pagination="customPagination"
      :enable-search="enableSearch"
      :button-items="buttonItems"
      :item-names="itemNames"
      :operation="operation"
      :row-selection="rowSelection"
      :load-data="loadData"
      :page-size="pageSize"
      :request-promise="requestPromise"
      :request-type="requestType"
      :rowKey="rowKey"
      :extraPaginationName="extraPaginationName"
    >
      <template v-for="item in [...itemNames,...buttonItems]" :slot="item">
        <slot :name="item"></slot>
      </template>
      <template v-for="(item, i) in customRenders" :slot="item" slot-scope="rowItem">
        <slot :name="item" :text="rowItem.text" :record="rowItem.record" :index="rowItem.index"></slot>
      </template>
      <template :slot="extraPaginationName">
        <slot :name="extraPaginationName"></slot>
      </template>
    </search-page-view>
    <slot name="footer"></slot>
  </a-modal>
</template>

<script>
export default {
  name: 'SelectedProductDialog',

  props: {
    title: {
      type: String,
      default: '选择商品'
    },
    width: {
      type: Number,
      default: 800
    },
    show: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    leftSpace: {
      type: Number,
      default: 0
    },
    itemNames: {
      type: Array,
      default: function() {
        return []
      }
    },
    buttonItems: {
      type: Array,
      default: function() {
        return []
      }
    },
    col: {
      type: Number,
      default: 3
    },
    buttonCol: {
      type: Number,
      default: 0
    },
    requestType: {
      type: String,
      default: 'post'
    },
    //查询式请求路径
    queryPath: {
      type: String,
      default: ''
    },
    //参数式请求路径
    paramsPath: {
      type: String,
      default: ''
    },
    //请求基础模块
    baseKey: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    rowSelection: {
      type: Object,
      default: null
    },
    operation: {
      type: String,
      default: 'operation'
    },
    enableSearch: {
      type: Boolean,
      default: true
    },
    //查询参数
    queryParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    //请求的
    requestPromise: {
      type: Function,
      default: undefined
    },

    loadData: {
      type: Function,
      default: undefined
    },
    // 自定义分页显示
    customPagination: {
      type: Boolean,
      default: true
    },
    //分页附加信息
    extraPaginationName: {
      type: String,
      default: 'extraPaginationName'
    },
    beforeSearch: {
      type: Function,
      default: undefined
    },
    rowKey: {
      type: String,
      default: ''
    }
  },
  data() {

    return {
      showSelectedDialog: false,
      customRenders: []
    }
  },
  watch: {
    'show': function(value) {
      this.showSelectedDialog = value
    }
    ,
    'columns': function(columnsList) {
      this.customRenders = this.getCustomRendersList(columnsList)
    }
  },
  mounted() {
    this.customRenders = this.getCustomRendersList(this.columns)
  },
  methods: {
    refresh(bool = false) {
      if (this.$refs.pageList) {
        this.$refs.pageList.refresh(bool)
      }
    },
    updateSelect(selectedRowKeys, selectedRows) {
      this.$refs.pageList.updateSelect(selectedRowKeys, selectedRows)
    },
    onCloseEvent() {
      this.showSelectedDialog = false
      this.$emit('close')
    },
    getCustomRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          // scopedSlots: { customRender: 'state' }
          if (item && item.scopedSlots && item.scopedSlots.customRender) {
            customList.push(item.scopedSlots.customRender)
          }
        })
      }
      return customList
    }
  }

}
</script>
<style scoped>
</style>